import cx from 'classnames';
import { useState } from 'react';
import { Announcement, Navbar, Sidebar, Spacer } from '../../components';
export default function Mintbot() {
  const [closeSide, setCloseSide] = useState(false)
  const [ann, setAnn] = useState(true)
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }
  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })
  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            {
              ann && <Announcement
                message="We have not released the token yet, but consider airdrop for those who test the mobile version apps"
                onClick={() => setAnn(false)}
                varian="dark"
              />
            }
            <div className="cardContainer">
              <span className="d-block">Having difficulties minting a new release NFT? Yes, we successfully developed the mint bot.</span>
              <span className="d-block">Play through the video below or go straight to the transaction hash link</span>
              <span className="d-block">Supported network: BSC, ETH, Polygon, Avalanche and Arbitrum.</span>
            </div>
            <Spacer h={20} />
            <div className="cardContainer">
              <video className="img-fluid" controls src="/media/mintbot.m4v" />
            </div>
            <Spacer h={20} />
            <div className="cardContainer">
              <span>BSC Testnet</span>
              <p>
                Txn hash :
                <a className="ms-2" style={{ color:'blueviolet' }} href="https://testnet.bscscan.com/tx/0x6b74f3e5346c214b97694e3cb633cab1591f7d646e23c9ef843dd4561616fec6" target="_blank">0x6b74f3e5346c214b97694e3cb633cab1591f7d646e23c9ef843dd4561616fec6</a>
              </p>
              <Spacer h={20} />
              <span>ETH Rinkeby</span>
              <p> Txn hash :<a className="ms-2" style={{ color:'blueviolet' }} href="https://rinkeby.etherscan.io/tx/0xd2bd4e37a88565d05ba7e2f20222abba53426c9d0af391c406fda494fb16faad" target="_blank">0xd2bd4e37a88565d05ba7e2f20222abba53426c9d0af391c406fda494fb16faad</a></p>
            </div>
            <Spacer h={20} />
          </div>
        </div>
      </div>
    </div>
  )
}
